import styled from 'styled-components/macro';

export namespace S {
	export const Buttons = styled.div`
		display: flex;
		gap: 4px;
	`;
}
